import { CustomButton } from "../../components/CustomButton/CustomButton.component";
import { Grid } from "@mui/material";

const TransactionViewAction = ({
  transaction,
  auth,
  handleSubmit,
  onEditTransaction,
  onResendCouponHandler,
  setRejectModal,
  onProcessApprove,
  setDiscardModal,
}) => {
  return (
    <>
      <div className="TransactionView__actions--container">
        <Grid
          container
          spacing={2}
          style={{ justifyContent: "center", alignItems: "center" }}
        >
          {transaction.status !== "PENDING" && auth.role === "SUPER_ADMIN" && (
            <>
              <Grid item xs={12} md={3} lg={2}>
                <CustomButton
                  classes={{
                    root: "TransactionView__actions--container-button",
                  }}
                  onClick={handleSubmit(onEditTransaction)}
                  title="Edit"
                />
              </Grid>
              <Grid item xs={12} md={3} lg={2}>
                <CustomButton
                  classes={{
                    root: "TransactionView__actions--container-button",
                  }}
                  onClick={onResendCouponHandler}
                  title="RESEND COUPONS"
                />
              </Grid>
            </>
          )}
          {transaction.status === "PENDING" && auth.role !== "AUDITOR" && (
            <>
              <Grid item xs={12} md={3} lg={2}>
                <CustomButton
                  onClick={() => setRejectModal(true)}
                  classes={{
                    root: "TransactionView__actions--container-button reject",
                  }}
                  title="Reject"
                />
              </Grid>
              <Grid item xs={12} md={3} lg={2}>
                <CustomButton
                  onClick={handleSubmit(onProcessApprove)}
                  classes={{
                    root: "TransactionView__actions--container-button approve",
                  }}
                  title="Approve"
                />
              </Grid>
              <Grid item xs={12} md={3} lg={2}>
                {auth.role !== "AGENT" && (
                  <CustomButton
                    onClick={() => setDiscardModal(true)}
                    classes={{
                      root: "TransactionView__actions--container-button",
                    }}
                    title="Discard"
                  />
                )}
              </Grid>
            </>
          )}
        </Grid>
      </div>
    </>
  );
};
export default TransactionViewAction;
